import { Component, ElementRef, Input, OnInit, ViewChildren } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TransferSchoolTn } from '@ascschool/model/transfer/transfer-school-aou.model';
import { DistrictService } from '@ascschool/services/category/district.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { TransferSchoolTnService } from '@ascschool/services/transfer/transferschooltn.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { Observable } from 'rxjs';

@Component({
  selector: 'chuyen-nkt-tiepnhan-xuly',
  templateUrl: './chuyen-nkt-tiepnhan-xuly.component.html',
  styleUrls: ['./chuyen-nkt-tiepnhan-xuly.component.scss']
})
export class ChuyenNktTiepnhanXulyComponent implements OnInit {
  @ViewChildren("label") labelElement: ElementRef;
  @Input() value: any;
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  transferSchool = new TransferSchoolTn();
  errorMsg: string;
  isDisabled = false;
  validateForm = new FormGroup({
    id: new FormControl(0),
    studentCode: new FormControl(null),
    provinceId: new FormControl(null),
    districtId: new FormControl(null),
    transferToEatosId: new FormControl(null),
    transferDate: new FormControl(null),
    transferReason: new FormControl(null),
    processingDate: new FormControl(null, Validators.required),
    processingNote: new FormControl(null)
  });
  idControl = this.validateForm.controls.id;
  studentCodeControl = this.validateForm.controls.studentCode;

  provinceControl = this.validateForm.controls.provinceId;
  districtControl = this.validateForm.controls.districtId;
  transferToEatosIdControl = this.validateForm.controls.transferToEatosId;

  transferTransferDateControl = this.validateForm.controls.transferDate;
  transferTransferReasonControl = this.validateForm.controls.transferReason;
  transferprocessingDateControl = this.validateForm.controls.processingDate;
  transferprocessingNoteControl = this.validateForm.controls.processingNote;

  getProvinceACFn: (value: any) => Observable<any>;
  getDistrictACFn: (value: any) => Observable<any>;
  getTransferToEatosACFn: (value: any) => Observable<any>;
  constructor(
    private modal: NzModalRef, private msg: NzMessageService, public utilsService: UtilsService,
    private service: TransferSchoolTnService) {
  }

  ngOnInit() {
    this.transferSchool.id = this.value.id;
    this.idControl.setValue(this.value.id);
    this.studentCodeControl.setValue(this.value.studentCode);
    this.transferSchool.studentCode = this.value.studentCode;
    this.transferSchool.fullName = this.value.fullName;
    this.transferSchool.gender = (this.value.gender == 1 ? 'Nam' : this.value.gender == 0 ? 'Nữ' : '');
    this.transferSchool.yearOfBirth = this.value.yearOfBirth;
    this.transferSchool.typeOfDisabilityName = this.value.typeOfDisabilityName;
    this.transferSchool.levelName = this.value.levelName;
    this.transferSchool.educationAndTrainingName = this.value.educationAndTrainingName;
    this.transferSchool.provinceName = this.value.provinceName;
    this.transferSchool.districtName = this.value.districtName;
    this.GetById(this.value.id);
  }

  dateFormat = 'dd/MM/yyyy';
  footerRender = () => 'Ngày tiếp nhận';
  GetById(id: number) {
    this.service.getTransferSchoolById(id).subscribe((res: any) => {
      if (res.id > 0) {
        this.transferSchool.studentId = res.studentId;
        this.transferSchool.transferToEatosId = res.transferToEatosId;
        this.transferSchool.transferDate = res.transferDate;
        this.transferSchool.transferReason = res.transferReason;
        this.transferTransferDateControl.setValue(res.transferDate);
        this.transferTransferReasonControl.setValue(res.transferReason);
      }
    });
  }

  valueIfHas(control: AbstractControl) {
    if (control.value && typeof control.value != 'string') return control.value.id;
    return '';
  }

  close() {
    this.destroyModal();
  }

  destroyModal(): void {
    this.modal.destroy(true);
  }

  UpdateClose() {
    if (this.validateForm.valid) {
      this.service.updatetransferSchool(this.bindOfDataId(this.validateForm)).subscribe((res) => {
        if (res.statusCode === 0) {
          this.notification(res);
          this.close();
        } else {
          this.notification(res);
        }
      }, error => {
        this.msg.error('lỗi: ' + error.error.Message);
      });
    } else {
      this.utilsService.showNotifyInvalidControls(this.validateForm, this.labelElement);
    }
  }
  bindOfDataId(formGroup: FormGroup) {
    let data;
    data = formGroup.value;
    const controls = formGroup.controls;
    for (const name in controls) {
      if (data[name] && data[name].id) {
        data[name] = data[name].id
      }
    }
    return data;
  }
  notification(response) {
    if (response.statusCode === 0) {
      this.msg.success('Cập nhật thông tin: ' + response.message);
    } else {
      this.msg.error('Lỗi: ' + response.message);
    }
  }

  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));

    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
}
